import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Divider, IconButton, List } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import { useBreakpoint } from 'common/hooks';

import { getDrawerSizeInPX } from './helpers';
import Logo from './Logo';
import StyledDrawer from './StyledComponents/StyledDrawer';

const SecondaryDrawer = ({
    children,
    container,
    drawerSize,
    handleDrawerToggle,
    mobileOpen,
    onClose,
    setSidebarOpen,
}) => {
    const breakpoint = useBreakpoint();
    const isMobile = ['xs', 'sm'].includes(breakpoint);

    const onCloseHandler = () => {
        if (onClose) onClose();
        if (setSidebarOpen) setSidebarOpen(false);
    };
    return (
        <StyledDrawer
            container={container}
            open={mobileOpen}
            onClose={onCloseHandler}
            sx={{
                '& .MuiDrawer-paper': {
                    marginLeft: isMobile ? 0 : getDrawerSizeInPX(drawerSize),
                    padding: 1.5,
                    width: isMobile ? '100%' : getDrawerSizeInPX('normal'),
                },
                '& .MuiBackdrop-root': { background: 'transparent' },
                zIndex: (theme) =>
                    isMobile
                        ? theme.zIndex.appBar + 100
                        : theme.zIndex.appBar - 1,
            }}
            variant="temporary"
        >
            {isMobile && (
                <>
                    <Box
                        display="flex"
                        sx={{
                            alignItems: 'center',
                            justifyContent: {
                                md: 'center',
                                xs: 'space-between',
                            },
                            px: { md: 0, xs: 2 },
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                my: isMobile ? 0 : 1,
                            }}
                        >
                            <IconButton
                                onClick={() => {
                                    handleDrawerToggle();
                                    onClose();
                                }}
                                sx={{ width: '100%' }}
                            >
                                <Logo field={'logotype_image'} />
                            </IconButton>
                        </Box>

                        <IconButton onClick={onClose}>
                            <ArrowBackIcon />
                        </IconButton>
                    </Box>

                    <Divider sx={{ mb: 2 }} />
                </>
            )}

            <List disablePadding>{children}</List>
        </StyledDrawer>
    );
};

SecondaryDrawer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    container: PropTypes.func,
    drawerSize: PropTypes.string,
    handleDrawerToggle: PropTypes.func,
    mobileOpen: PropTypes.bool,
    onClose: PropTypes.func,
    setSidebarOpen: PropTypes.func,
};

export default SecondaryDrawer;
